<template>
  <th class="text-left">
    <div
      style="display: flex; align-items: center; cursor: pointer"
      @click="$emit('click')"
    >
      <span :class="{ aelink: smallScreen }" class="header-text">{{
        label
      }}</span>
      <img
        style="margin-left: 6px; width: 14px; height: 14px"
        src="../../assets//icons-action-alert@2x.png"
      />
    </div>
  </th>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      smallScreen: false, // Inicializa la propiedad smallScreen
    };
  },
  // Otros métodos y propiedades del componente
};
</script>
